import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const getTransactionsData = createAsyncThunk(
  "transactions/getTransactionsData",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(
        `${BASE_URL}/Transanctions`, params
      );
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getTransactionDocument = createAsyncThunk(
  "transactions/getTransactionDocument",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/Transanctions/document`, {
        ...params,
        authorization: localStorage.getItem("userToken"),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: "Unable to download document" });
    }
  }
);
